/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { createApiResponseSchema, type IAPI } from '../../apiResponse';
import { collectionTypeSchema, type ICollectionType } from '../../collections';

export const watchlistItemSchema = z.object({
  collectionId: z.number(),
  slug: z.string(),
  title: z.string(),
  type: collectionTypeSchema,
  posterUrl: z.string().nullable(),
});

export interface IWatchlistItem {
  collectionId: number;
  slug: string;
  title: string;
  type: ICollectionType;
  posterUrl: string | null;
}

const watchlistDataSchema = z.object({
  items: z.array(watchlistItemSchema),
  nextCursor: z.string().nullable(),
});

export interface IWatchlistData {
  items: IWatchlistItem[];
  nextCursor: string | null;
}

export const getMyWatchlistV1ResponseSchema = createApiResponseSchema(
  watchlistDataSchema,
) as z.ZodSchema<IAPI<IWatchlistData>>;

export type IGetMyWatchlistV1Response = IAPI<IWatchlistData>;
